var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileBlackWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9845 5.3963C14.9843 4.81865 14.8704 4.2467 14.6491 3.71312C14.4278 3.17953 14.1036 2.69477 13.6949 2.28652C13.2862 1.87826 12.8012 1.55452 12.2673 1.33378C11.7335 1.11303 11.1615 0.999614 10.5838 1H1.73603C1.54082 1 1.35361 1.07755 1.21558 1.21558C1.07755 1.35361 1 1.54082 1 1.73603V17.1926C1 17.3878 1.07755 17.575 1.21558 17.7131C1.35361 17.8511 1.54082 17.9287 1.73603 17.9287H14.2331C14.4283 17.9287 14.6155 17.8511 14.7535 17.7131C14.8915 17.575 14.9691 17.3878 14.9691 17.1926L14.9845 5.3963Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6678 2.2623C12.8463 1.45166 11.738 0.998029 10.5838 1.00001H1.73603C1.54082 1.00001 1.35361 1.07755 1.21558 1.21558C1.07755 1.35362 1 1.54083 1 1.73604V14.9301L13.6678 2.2623Z",
    fill: "#F9FAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9418 4.68006H12.0559C11.8606 4.68006 11.6734 4.60252 11.5354 4.46448C11.3974 4.32645 11.3198 4.13924 11.3198 3.94403V1.06616C12.2259 1.21356 13.0628 1.64163 13.7126 2.29C14.3625 2.93837 14.7924 3.77434 14.9418 4.68006V4.68006Z",
    fill: "#F9FAFB",
    stroke: "#00303E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2639 17.9287C14.4591 17.9287 14.6463 17.8511 14.7843 17.7131C14.9224 17.575 14.9999 17.3878 14.9999 17.1926V5.3963C14.9995 4.23019 14.536 3.11198 13.7113 2.28756C12.8866 1.46313 11.7683 1 10.6022 1H1.75141C1.5562 1 1.36899 1.07755 1.23096 1.21558C1.09293 1.35361 1.01538 1.54082 1.01538 1.73603V17.1926C1.01538 17.3878 1.09293 17.575 1.23096 17.7131C1.36899 17.8511 1.5562 17.9287 1.75141 17.9287H14.2639Z",
    stroke: "#00303E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlackWhite);
export default __webpack_public_path__ + "static/media/file-black-white.51dc5df0ba6721aeb3cdc963996d60f1.svg";
export { ForwardRef as ReactComponent };